/**
 * Şablon dilleri (ISO 639-1).
 *
 * Tek kaynak: rapor çıktı şablonları, onam formu şablonları ve builder aynı listeyi kullanır.
 * Daha önce HospitalRowMenu içinde tanımlıydı; oradan da geriye uyumluluk için yeniden dışa aktarılır.
 */
export const TemplateLanguages = ['tr', 'en', 'de', 'fr', 'es', 'ru', 'az', 'uz']

export default TemplateLanguages
